<template>
  <div>
    <nav>
      <v-app-bar text>
        <v-toolbar-title class="text-uppercase grey--text">
          <span>Admin</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text color="blue" @click="exportExcelAction">
          <span>Export in Excel</span>
        </v-btn>
        <v-btn text color="grey">
          <span>Sign Out</span>
          <v-icon right aria-hidden="true">exit</v-icon>
        </v-btn>
      </v-app-bar>
    </nav>
    <div>
      <table aria-label="Elenco partecipanti">
        <thead>
          <tr>
            <th scope="col">Matricola</th>
            <th scope="col">Data</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(mat, ky) in dt.names" v-bind:key="ky">
            <td
              @click="det(mat.id)"
              @keydown.enter="det(mat.id)"
              role="button"
              tabindex="0"
            >{{ mat.name }}</td>
            <td>{{ mat.date }}</td>
          </tr>
        </tbody>
      </table>
      {{ dataDetails }}
    </div>

    <!--<gethtmlrender :jsonData="dt.raw"></gethtmlrender>-->
    <div id="appendhere"></div>
  </div>
</template>

<script>
import Api from "@/services/Api.js";
//import gethtmlrender from "./gethtmlrender.vue";
export default {
  components: {
    //gethtmlrender,
  },
  data() {
    return {
      drawer: false,
      group: null,
      dt: { raw: {}, names: [] },
      dataDetails: {},
    };
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    logout() {
      this.$store.commit("cardLogged", false);
    },
    fetchData() {
      Api()
        .get("/cardGame/get")
        .then((result) => {
          this.dt.raw = result.data;

          this.dt.raw.map((p) => {
            this.dt.names.push({ id: p._id, name: p.fullname, date: p.date });
          });
        })
        .catch((error) => {});
    },
    det(o) {
      this.dataDetails = this.dt.raw.filter((s) => s._id == o);
    },
    manageData() {
      let newData = this.dt.raw;
      newData.forEach((user) => {
        user.results.forEach((result) => {
          result.scores.sort((a, b) => a.dataIndex - b.dataIndex);
        });
      });
      console.log("ppp", newData);

      let h = "";
      h += "<table id='export'>";
      h += "<tr>";
      h += "<th>Date</th><th>Name</th><th>Email</th>";
      console.log("step1", h);

      newData[0].results[0].scores.forEach((sca) => {
        h += "<th>" + sca.question + "</th>";
      });
      h += "</tr>";
      console.log("step2", h);

      newData.forEach((user) => {
        let name = user.fullname;
        let email = user.email;
        let nameElements = "<td>" + name + "</td><td>" + email + "</td>";
        user.results.forEach((result) => {
          result.scores.sort((a, b) => a.dataIndex - b.dataIndex);
          h += "<tr>";
          h += "<td>" + result.trydate + "</td>";

          h += nameElements;
          result.scores.forEach((sc) => {
            h +=
              "<td>" +
              (sc.result == 1 ? String(sc.timer).replace(".", ",") : 5) +
              "</td>";
          });
          h += "</tr>";
        });
      });
      h += "</table>";
      //console.log("tabella", h);
      return h;
    },
    exportTableToExcel(tableID, filename = "") {
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = document.getElementById(tableID);
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

      // Specify file name
      filename = filename ? filename + ".xls" : "excel_data.xls";

      // Create download link element
      downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      // Create a link to the file
      downloadLink.href = "data:" + dataType + ", " + tableHTML;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
     
      downloadLink.click();
      document.getElementById(tableID).remove();
      
    },
    exportExcelAction() {
      let table = this.manageData();
      document.querySelector("#appendhere").innerHTML = table;
      this.exportTableToExcel("export");
    },
  },
};
</script>

<style>
</style>